// @flow
import Upload from './Upload';
import AssetUploadJob from './AssetUploadJob';
import Store from '../store/Store';
import { ASSET_UPLOAD_JOBS, UPLOAD_SCHEDULER } from '../store/Constants';
import UploadScheduler from './UploadScheduler';
import FileNode from '../protocol/FileNode';
import FutureJob from '../protocol/FutureJob';
import CreateFolderJob from './CreateFolderJob';
import _ from 'lodash';
import System from '../basic/System';
import NativeActionUtil from '../util/NativeActionUtil';
import loginRequired from '../auth/loginRequired';

const scheduler: UploadScheduler = Store.get(UPLOAD_SCHEDULER);

type UploadConfig = {
  isModernUpload: boolean,
  projectName: ?string,
  uploadPath: ?string
};

export default class UploadAssets {
  /**
   * Uploads the given files then runs the ImportQuery.
   */
  @loginRequired
  static uploadAssetsAndImport(files: File[] | FileNode[], config: ?UploadConfig = {}): FutureJob[] {
    if (System.isDesktop()) {
      const inFiles: Array = [];
      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          if (files[i].file) {
            inFiles.push(files[i].file.path);
          } else {
            inFiles.push(files[i].path);
          }
        }
        /*const query = new ImportQueryQuery();
        const msg = new ImportQueryMsg();
        msg.setFileNames(inFiles);
        msg.setPath(config.uploadPath);
        query.message = msg;*/

        //const controller = ImportController.getInstance();
        //controller.issueCheckInQuery(query);
        window.gs.checkinDone = true;
        NativeActionUtil.runExecQuery(inFiles, 'checkin', config.uploadPath);
      }
      return null;
    } else {
      const { isModernUpload, projectName, uploadPath } = config ? config : {};
      let jobs: FutureJob[] = [];
      if (isModernUpload === true) {
        if (projectName && uploadPath) {
          jobs = files.map((node) => UploadAssets.visit(node, projectName, uploadPath));
        } else {
          //Find the files only files
          const onlyFiles: FileNode = UploadAssets.recursivelyFileFiles(files, []);
          if (onlyFiles.length > 0) {
            jobs = onlyFiles.map((node) => UploadAssets.visit(node, undefined, undefined));
          }
        }
      } else {
        jobs = [...files].map((file) => {
          const upload = new Upload(file, uploadPath);
          const job = new AssetUploadJob(upload);
          scheduler.add(job);
          return job;
        });
      }

      const allJobs = Store.get(ASSET_UPLOAD_JOBS).concat(UploadAssets.flatten(jobs));
      Store.put(ASSET_UPLOAD_JOBS, allJobs);

      return jobs;
    }
  }

  static isFolder(file: File) {
    return file.type === 'folder';
  }

  static recursivelyFileFiles(files: FileNode[], collectionedFiles: FileNode[] = []) {
    let current: FileNode;
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        current = files[i];
        if (UploadAssets.isFolder(current)) {
          collectionedFiles = UploadAssets.recursivelyFileFiles(current.children, collectionedFiles);
        } else {
          collectionedFiles.push(current);
        }
      }
    }
    return collectionedFiles;
  }

  static visit(fileNode: FileNode, projectName: ?string, uploadPath: ?string) {
    let job: FutureJob;

    if (UploadAssets.isFolder(fileNode)) {
      if (projectName && uploadPath) {
        job = new CreateFolderJob(fileNode.file.name, projectName, uploadPath);
        scheduler.add(job);
        job.children = fileNode.children.map((child) => {
          const childUploadPath = `${uploadPath}/${fileNode.file.name}`;
          return UploadAssets.visit(child, projectName, childUploadPath);
        });
      }
    } else {
      const upload = new Upload(fileNode.file, uploadPath);
      job = new AssetUploadJob(upload);
      scheduler.add(job);
    }

    return job;
  }

  static flatten(jobs: FutureJob[]) {
    const arr = [];

    const visit = (job: FutureJob) => {
      arr.push(job);
      job.children.forEach(visit);
    };

    jobs.forEach(visit);

    return arr;
  }
}
export const uploadAssets = UploadAssets.uploadAssetsAndImport;
